// Centralized billing client used by Plans.js, Billing.js and BillingSuccess.js
// Talks to the FastAPI backend which proxies Stripe + syncs Supabase.

const API = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '') || '';

async function jsonFetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  let data = null;
  try { data = await res.json(); } catch { /* non-json */ }
  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function createCheckoutSession({ planId, userId, email, name }) {
  return jsonFetch('/api/billing/checkout-session', {
    method: 'POST',
    body: JSON.stringify({
      plan_id: planId,
      user_id: userId,
      email,
      name,
      success_url: `${window.location.origin}/billing/success?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${window.location.origin}/app/plans`,
    }),
  });
}

export async function getCheckoutSession(sessionId) {
  return jsonFetch(`/api/billing/session/${encodeURIComponent(sessionId)}`);
}

export async function createCustomerPortal({ userId, email }) {
  return jsonFetch('/api/billing/customer-portal', {
    method: 'POST',
    body: JSON.stringify({
      user_id: userId,
      email,
      return_url: `${window.location.origin}/app/billing`,
    }),
  });
}

export async function fetchBillingPlans() {
  return jsonFetch('/api/billing/plans');
}
